// @ts-nocheck
import { Trans, withI18n } from '@lingui/react'
import { InferProps, number, string } from 'prop-types'
import * as React from 'react'
import { FunctionComponent, useEffect, useState } from 'react'
import { compose } from 'redux'

import Price from 'views/components/atoms/Price'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import withMountPoints from 'views/enhancers/withMountPoints'
import { setTimeleft } from 'views/utils/nowCountdownTimer'
import 'views/components/organisms/NowShippingModal/NowShippingModal.scss'

type NowDeliveryBoxProps = InferProps<typeof nowDeliveryBoxProps>

const NowDeliveryBox: FunctionComponent<NowDeliveryBoxProps> = ({
  deliveryDay,
  deliveryTimeInfo,
  minimumOrder,
  deliveryRedpoints,
  secondsLeft,
  deliveryCost,
  carrierName,
}: NowDeliveryBoxProps): React.ReactElement => {
  const capitalizeFirstLetter = lowercaseString => {
    return lowercaseString.charAt(0).toUpperCase() + lowercaseString.slice(1)
  }
  let deliveryTime

  const [countdownTime, setCountdownTime] = useState(secondsLeft)
  const [timeLeft, setTimeLeft] = useState('')

  useEffect(() => {
    setCountdownTime(secondsLeft?.toString())
  }, [secondsLeft])

  useEffect(() => {
    const interval = setTimeleft(countdownTime, setTimeLeft, setCountdownTime)

    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [countdownTime])

  if (deliveryDay) {
    deliveryTime = `${capitalizeFirstLetter(deliveryDay)}, ${deliveryTimeInfo}`
  }

  return (
    <div className="o-NowDeliveryBox l-flex l-flex__column l-flex__row@medium">
      <div className="o-leftBox">
        <span className="o-DeliveryMessage">
          <Trans id="general.label.now.deliveryMessage" />
        </span>
        <br />

        <span className="o-DeliveryDay">{deliveryDay}</span>
        <br />
        <span className="o-DeliveryTime">
          <TransWithHtml
            id="general.label.now.timeleft"
            values={{ timeLeft }}
          />
        </span>
      </div>
      <div className="o-rightBox">
        <div className="o-textWrapper">
          <span className="o-leftMessage">
            <Trans id="general.label.now.deliveryWindow" />
          </span>
          <span className="o-rightMessage">{deliveryTime || '--'}</span>
        </div>
        <div className="o-textWrapper">
          <span className="o-leftMessage">
            <Trans id="general.label.now.deliveryCost" />
          </span>
          <span className="o-rightMessage">
            <Price amount={deliveryCost / 100} />
          </span>
        </div>
        <div className="o-textWrapper">
          <span className="o-leftMessage">
            <Trans id="general.label.now.deliveryRedpoints" />
          </span>
          <span className="o-rightMessage">
            <Price amount={deliveryRedpoints / 100} />
          </span>
        </div>
        <div className="o-textWrapper">
          <span className="o-leftMessage">
            <Trans id="general.label.now.minimumOrder" />
          </span>
          <span className="o-rightMessage">
            <Price amount={minimumOrder / 100} />
          </span>
        </div>
        <div className="o-textWrapper">
          <span className="o-leftMessage">
            <Trans id="general.label.now.carrier" />
          </span>
          <span className="o-rightMessage">{carrierName || '--'}</span>
        </div>
      </div>
    </div>
  )
}

const nowDeliveryBoxProps = {
  deliveryDay: string,
  minimumOrder: number,
  deliveryCost: number,
  deliveryRedpoints: number,
  secondsLeft: number,
  carrierName: string,
  deliveryTimeInfo: string,
}

NowDeliveryBox.propTypes = nowDeliveryBoxProps

export default compose(withMountPoints)(withI18n()(NowDeliveryBox))
